import React from 'react';
import DetailIcon from '../ui/DetailIcon';
import { useTranslation } from '../../hooks/useTranslation';
import { HIGH_LIMIT_MULTIPLIER } from './bidGuidance';

const groups = [
  { key: 'before', questions: ['requirements', 'card'] },
  { key: 'bidding', questions: ['limits', 'steps', 'ties', 'changes', 'buyNow', 'timing', 'updates'] },
  { key: 'rules', questions: ['payment', 'nonPayment', 'moderation', 'beta'] },
];

export default function AuctionFAQ() {
  const { t } = useTranslation('auctions');
  const copy = key => t(key).replace('{multiplier}', HIGH_LIMIT_MULTIPLIER);

  return <section id="auction-faq" aria-labelledby="auction-faq-title" className="mt-8 scroll-mt-24 rounded-xl bg-krit-paper p-4 text-krit-surface sm:mt-12 sm:p-7">
    <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:gap-10">
      <div className="min-w-0">
        <span className="inline-flex rounded-md bg-krit-yellow px-2 py-1 text-[10px] font-extrabold uppercase tracking-wider">{t('faq.betaLabel')}</span>
        <h2 id="auction-faq-title" className="mt-3 text-[24px] font-black leading-tight tracking-tight sm:text-[28px]">{t('faq.title')}</h2>
        <p className="mt-3 text-sm leading-relaxed text-krit-muted">{t('faq.intro')}</p>
        <div className="mt-5 rounded-lg border border-krit-line bg-white p-4">
          <div className="flex items-center gap-2 text-sm font-extrabold"><DetailIcon name="info" className="h-5 w-5 shrink-0 text-krit-drop" /><h3>{t('faq.noticeTitle')}</h3></div>
          <p className="mt-3 text-xs leading-relaxed">{t('faq.paymentNotice')}</p>
          <p className="mt-3 text-xs leading-relaxed">{t('faq.betaNotice')}</p>
        </div>
      </div>
      <div className="min-w-0 space-y-6">
        {groups.map(group => <div key={group.key}>
          <h3 className="mb-2 text-xs font-extrabold uppercase tracking-wider text-krit-muted">{t(`faq.groups.${group.key}`)}</h3>
          <div className="divide-y divide-krit-line overflow-hidden rounded-lg bg-white">
            {group.questions.map(question => <details key={question} className="group">
              <summary className="flex min-h-[52px] cursor-pointer list-none items-center justify-between gap-3 px-4 py-4 text-sm font-bold hover:bg-krit-paper/50 focus-visible:outline focus-visible:-outline-offset-2 focus-visible:outline-teal-600 [&::-webkit-details-marker]:hidden">
                <span>{t(`faq.${question}.question`)}</span>
                <DetailIcon name="chevronRight" className="h-4 w-4 shrink-0 rotate-90 text-krit-drop group-open:-rotate-90" />
              </summary>
              <div className="space-y-3 px-4 pb-5 text-sm leading-relaxed text-krit-muted">
                <p>{copy(`faq.${question}.answer`)}</p>
                <p>{copy(`faq.${question}.detail`)}</p>
              </div>
            </details>)}
          </div>
        </div>)}
      </div>
    </div>
  </section>;
}
